/** Depth in centimetres → level + advice. Bands: <20 / 20–50 / 50–100 / 100–150 / ≥150 cm. */
export function depthAdviceCm(cm) {
    if (cm < 20)
        return { key: "ankle", icon: "🦶", label: "ระดับข้อเท้า", advice: "เดินผ่านได้ ระวังลื่น ท่อระบายน้ำ และของมีคมใต้น้ำ", severity: "normal" };
    if (cm < 50)
        return { key: "knee", icon: "🦵", label: "ระดับเข่า", advice: "รถเล็กเสี่ยงดับ ควรเลี่ยงเส้นทางนี้ · บ้านชั้นล่างยกของและปลั๊กไฟขึ้นที่สูง", severity: "high" };
    if (cm < 100)
        return { key: "waist", icon: "🧍", label: "ระดับเอว", advice: "อันตราย อย่าขับรถหรือเดินลุยน้ำ กระแสน้ำพัดล้มได้ · ตัดไฟชั้นล่าง", severity: "high" };
    if (cm < 150)
        return { key: "chest", icon: "🆘", label: "ระดับอก", advice: "อันตรายมาก ออกจากพื้นที่ไปที่สูงหรือศูนย์พักพิง โทร 1784", severity: "veryhigh" };
    return { key: "over", icon: "☠️", label: "มิดศีรษะ", advice: "อันตรายมาก ห้ามเข้าพื้นที่ อยู่บนที่สูงรอความช่วยเหลือ โทร 1784", severity: "veryhigh" };
}
/** Depth in metres → level + advice (convenience for the API, which works in metres). */
export function depthAdviceM(m) { return depthAdviceCm(m * 100); }
//# sourceMappingURL=depth-advice.js.map